import React from 'react';

var UpdatePackagePopup = React.createClass({
	handleStopPropogation: function(e) {
    	e.stopPropagation();
  	},
  	handleCloseClick: function(){
    	this.props.updatePackage("close");
  	},
  	handleUpdateClick: function (){
  		this.props.updatePackage("submit");
  	},
  	handleVersionClick: function(name, event){
		event.stopPropagation();
		/* for opening the make canonical popup */
		if(name === "make"){
			var e = event.target.parentElement.firstChild;
		} else {
			var e = event.target.parentElement;
		}
		$(".ver__status--container").not(e).removeClass('clicked'); // closes make canonical popup
	    var $menuItem = $(e),
	        $submenuWrapper = $('> .tooltip', $menuItem);
	    
	    // grab the menu item's position relative to its positioned parent
	    var menuItemPos = $menuItem.position();
	    
	    // place the submenu in the correct position relevant to the menu item
	    $submenuWrapper.css({
	      top: menuItemPos.top + Math.round($menuItem.outerWidth() * 1),
	      left: menuItemPos.left + Math.round($menuItem.outerWidth() * .4)
	    });

		$(e).toggleClass('clicked');

	},
	formatAMPM: function(date) {
	  	var hours = date.getHours();
	  	var minutes = date.getMinutes();
	  	var ampm = hours >= 12 ? 'pm' : 'am';
	  	hours = hours % 12;
	  	hours = hours ? hours : 12; // the hour '0' should be '12'
	  	minutes = minutes < 10 ? '0'+minutes : minutes;
	  	var strTime = hours + ':' + minutes  + ampm;
	  	return strTime;
	},
	handleMakeCanonicalClick: function(label, e){  //opens the make canonical popup
		this.props.makeCanonicalSnapshot(label);
		$(e.target.parentElement.parentElement.parentElement).toggleClass('clicked');
	},
	handleCancelCanocicalClick: function(label, e){ // closes the make canonocal popup
		$(e.target.parentElement.parentElement.parentElement).toggleClass('clicked');
	},
	handleScroll: function(){
		$(".ver__status--container").removeClass('clicked'); // closes make canonical popup
	},
	sort: function(sortName){
		if(this.props.sort === "date" && this.props.isSort){
			this.props.data.sort(function(a,b){
			  return new Date(b.created_date) - new Date(a.created_date);  // for sorting date wise
			});
		} else if (this.props.sort === "date" && !this.props.isSort){
			this.props.data.sort(function(a,b){
			  return new Date(a.created_date) - new Date(b.created_date);  // for sorting date wise
			});
		}

		if(this.props.sort === "label" && this.props.isSort){
			this.props.data.sort(function(a, b){
			    var nameA=a.label.toLowerCase(), nameB=b.label.toLowerCase()
			    if (nameA < nameB) //sort string ascending
			        return -1 
			    if (nameA > nameB)
			        return 1
			    return 0 //default return value (no sorting)
			});
		} else if(this.props.sort === "label" && !this.props.isSort) {
			this.props.data.sort(function(a, b){
			    var nameA=a.label.toLowerCase(), nameB=b.label.toLowerCase()
			    if (nameB < nameA) //sort string descending
			        return -1 
			    if (nameB > nameA)
			        return 1
			    return 0 //default return value (no sorting)
			});
		}

	},
  	render: function() {
  		this.sort(this.props.sort);	 // for sortings
		var data = this.props.data;
		var flag = false;
		for (var i in data){
			if(this.props.data[i]["canonical"]){
				flag = true;
			}
		}
		/*for the recent date in the data */
		var recentDate = new Date(Math.max.apply(null, data.map(function(e) {
		  return new Date(e.created_date);
		})));

		var result = data.map(function(value, index){
			var date = new Date(value["created_date"]);
			var dateInString = (date.getMonth() + 1) + "/" + date.getDate() + "/" + date.getFullYear().toString().substr(-2) + ", " + this.formatAMPM(date);
			if (value["canonical"]){
				return (<li className="ver__item canonical__item" key = {index}>
			              <div className="ver__label">{value["label"]}</div>
			              <div className="ver__status"> 
			              	<a href="javascript:void(0)" className="tooltip__container ver__status--container">
			              		<i className="fa fa-star"></i> 
			              	</a> 
			              	<span className="ver__status--visible">canonical</span>
			               </div>
			              <div className="ver__date_n_time">{dateInString}</div>
			            </li>
			    );
			} else {
				if(!flag && (recentDate.valueOf() === new Date(value.created_date).valueOf())){
					return (
						<li className="ver__item recent__item" key = {index}>
			              	<div className="ver__label">{value["label"]}</div>
			              	<div className="ver__status">
			               		<a href="javascript:void(0)" className="tooltip__container ver__status--container no__hover" onClick = {this.handleVersionClick.bind(this, "star")}><i className= "fa fa-star"></i> 
			                		{/*<div className="tooltip tooltip--bottom tooltip--lg">
			                			<div className="form__row clearfix">
			                  				<h6>Make Version Snapshot Canonical</h6>
			                  				<p>The canonical version of a package represents the default version, unless otherwise specified. Your canonical version will be used for clone and pull.</p>
			                			</div>
			                			<div className="buttons clearfix">
			                  				<button className="btn__sm bg-very_light" onClick = {this.handleCancelCanocicalClick.bind(this, value["label"])}>Cancel</button>
			                 				<button className="btn__sm bg-dark" onClick = {this.handleMakeCanonicalClick.bind(this, value["label"])}>Make Canonical</button>
			                			</div>
			                		</div>*/}
			               		</a>
			               		<span className="ver__status--visible" onClick = {this.handleVersionClick.bind(this, "make")}>most recent</span>
			                	<span className="ver__status--hidden" onClick = {this.handleVersionClick.bind(this, "make")}>most recent{/*make canonical*/}</span>
			              	</div>
			              	<div className="ver__date_n_time">{dateInString}</div>
			            </li>
					);
				} else {
					return (
						<li className="ver__item recent__item" key = {index}>
			              	<div className="ver__label">{value["label"]}</div>
			              	<div className="ver__status">
			               		<a href="javascript:void(0)" className="tooltip__container ver__status--container no__hover" onClick = {this.handleVersionClick.bind(this, "star")}><i className= "fa fa-star-o"></i> 
			                		{/*<div className="tooltip tooltip--bottom tooltip--lg">
			                			<div className="form__row clearfix">
			                  				<h6>Make Version Snapshot Canonical</h6>
			                  				<p>The canonical version of a package represents the default version, unless otherwise specified. Your canonical version will be used for clone and pull.</p>
			                			</div>
			                			<div className="buttons clearfix">
			                  				<button className="btn__sm bg-very_light" onClick = {this.handleCancelCanocicalClick.bind(this, value["label"])}>Cancel</button>
			                 				<button className="btn__sm bg-dark" onClick = {this.handleMakeCanonicalClick.bind(this, value["label"])}>Make Canonical</button>
			                			</div>
			                		</div>*/}
			               		</a>
			               		<span className="ver__status--visible" onClick = {this.handleVersionClick.bind(this, "make")}>&zwnj;&zwnj;</span>
			                	<span className="ver__status--hidden" onClick = {this.handleVersionClick.bind(this, "make")}>&zwnj;&zwnj;{/*make canonical*/}</span>
			              	</div>
			              	<div className="ver__date_n_time">{dateInString}</div>
			            </li>
					);
				}
			}
		}, this);
		/*code for changing the up and down arrow when click on either label or date*/
		var dateclass, labelclass;
		if(this.props.sort === "date" && this.props.isSort){
			dateclass = "fa fa-angle-up";
			labelclass = "";
		} else if (this.props.sort === "date" && !this.props.isSort){
			dateclass = "fa fa-angle-down";
			labelclass = "";
		} else if (this.props.sort === "label" && this.props.isSort){
			dateclass = "";
			labelclass = "fa fa-angle-up";
		} else if (this.props.sort === "label" && !this.props.isSort){
			dateclass = "";
			labelclass = "fa fa-angle-down";
		}
	    return (
			<div className="modal__mask" onClick = {this.handleCloseClick}>
			  <div className="modal__content modal--md" onClick = {this.handleStopPropogation}>
			    <div className="modal__header">
			      <h3 className="modal__header--title">Update This Package</h3>
			      <a href="javascript:void(0)" className="modal__close"><i className="fa fa-close"> </i></a> </div>
			    <div className="modal__body clearfix">
			      <div className="form__row clearfix">
			        <p>All the Lorem Ipsum generators on the Internet tend to repeat predefined chunks as necessary, making this the first true generator on the Internet.</p>
			      </div>
			      <div className="form__row clearfix">
			        <div className="two_fifths form__cell">
			          <label> <strong>Enter Account ID </strong><a className="tooltip__container"><i className="fa fa-question-circle"> </i> <span className="tooltip tooltip--top tooltip--sm"> Lorem ipsum dolor sit ametlabore et dolore magna aliqua. </span> </a> </label>
			          <div className="input_divider_icon">
			            <input type="text" defaultValue />
			          </div>
			        </div>
			        <div className="three_fifths form__cell">
			          <label> <strong>Select Package ID </strong><a className="tooltip__container"><i className="fa fa-question-circle"> </i> <span className="tooltip tooltip--top tooltip--sm"> Lorem ipsum dolor sit ametlabore et dolore magna aliqua. </span> </a> </label>
			          <div className="custom-dropdown custom-dropdown--default">
			            <select id="cd3" className="select-dropdown">
			              <option value="selected">Select</option>
			              <option>andres_attorney_theme</option>
			              <option>healthcare_theme</option>
			              <option>landscaping_architecture_theme</option>
			              <option>very_long_theme_name_that_gets_trunc...</option>
			            </select>
			          </div>
			        </div>
			      </div>
			      <div className="form__row clearfix">
			        <p>Select the version snapshot for package "<strong>Landscaping Architevture Theme</strong>" that you want to update.</p>
			      </div>
			      <div className="form__row clearfix">
			        <div className="ver__container">
			          <div className="ver__head clearfix"> <strong className="ver__head--label"><a href="#">Label</a></strong> <strong className="ver__head--date ver__head--scroll"><a href="#">Date <i className="fa fa-angle-up" /></a></strong> </div>
			          <div className="ver__body">
			            <ul className="ver__list list-unstyled">
			            {result}
			             {/*} <li className="ver__item">
			                <div className="ver__label">
			                  <div className="checkbox">
			                    <label htmlFor="andres_site_V2">
			                      <input defaultValue="None" id="andres_site_V2" name="check" type="checkbox" />
			                      landscape_architecture_new_5 </label>
			                  </div>
			                </div>
			                <div className="ver__status"> <i className="fa fa-star" /> <span className="ver__status--visible">canonical</span> </div>
			                <div className="ver__date_n_time">9/12/17, 11:30pm</div>
			              </li>
			              <li className="ver__item">
			                <div className="ver__label">
			                  <div className="checkbox">
			                    <label htmlFor="andres_site_V1">
			                      <input defaultValue="None" id="andres_site_V1" name="check" type="checkbox" />
			                      landscape_architecture_new_4</label>
			                  </div>
			                </div>
			                <div className="ver__status">&nbsp;</div>
			                <div className="ver__date_n_time">2/7/17, 11:30pm</div>
			              </li>
			              <li className="ver__item">
			                <div className="ver__label">
			                  <div className="checkbox">
			                    <label htmlFor="new_bannerdesign_V3">
			                      <input defaultValue="None" id="new_bannerdesign_V3" name="check" type="checkbox" />
			                      landscape_architecture_new_3</label>
			                  </div>
			                </div>
			                <div className="ver__status">&nbsp;</div>
			                <div className="ver__date_n_time">1/18/17, 9:00am</div>
			              </li>
			              <li className="ver__item">
			                <div className="ver__label">
			                  <div className="checkbox">
			                    <label htmlFor="new_bannerdesign_V2">
			                      <input defaultValue="None" id="new_bannerdesign_V2" name="check" type="checkbox" />
			                      landscape_architecture_new_2</label>
			                  </div>
			                </div>
			                <div className="ver__status">&nbsp;</div>
			                <div className="ver__date_n_time">12/12/16, 4:41pm</div>
			              </li>
			              <li className="ver__item">
			                <div className="ver__label">
			                  <div className="checkbox">
			                    <label htmlFor="new_bannerdesign_V1">
			                      <input defaultValue="None" id="new_bannerdesign_V1" name="check" type="checkbox" />
			                      landscape_architecture_new_1</label>
			                  </div>
			                </div>
			                <div className="ver__status">&nbsp;</div>
			                <div className="ver__date_n_time">11/27/16, 2:26pm</div>
			              </li>*/}
			            </ul>
			          </div>
			        </div>
			      </div>
			      <div className="buttons clearfix">
			        <button className="btn__lg bg-very_light" onClick = {this.handleCloseClick}>Cancel</button>
			        <button className="btn__lg bg-dark" onClick = {this.handleUpdateClick}>Update</button>
			      </div>
			    </div>
			  </div>
			</div>

	    );
  	}
});

export {UpdatePackagePopup};


/** WEBPACK FOOTER **
 ** ./html/components/DetailsPage/UpdatePackagePopup.jsx
 **/